<div *ngIf="!mobile" class="top" [ngStyle]="{ color: secondaryColor, 'background-color': primaryColor }">
  <h1 [ngStyle]="{ color: secondaryColor }" [innerHtml]="data.area.name | safeHTML"></h1>
  <button disableRipple="true" mat-icon-button matTooltip="Close" mat-dialog-close>
    <mat-icon>clear</mat-icon>
  </button>
</div>
<div *ngIf="mobile" class="top">
  <button disableRipple="true" mat-icon-button matTooltip="Close" mat-dialog-close>
    <mat-icon>west</mat-icon>
  </button>
  <h1 [ngStyle]="{ color: secondaryColor }" [innerHtml]="data.area.name | safeHTML"></h1>
</div>
<div class="area">
  <div *ngFor="let video of settings.videos; let i = index" class="video-container">
    <mat-icon *ngIf="videoPlaying === i" class="closeVideo" matTooltip="Close" (click)="shrinkVideo($event)">highlight_off</mat-icon>
    <mat-card class="card">
      <video class="video" controls (play)="enlargeVideo($event, i)">
        <source [src]="video.link | safe" type="video/mp4" />
      </video>
      <span class="subtitle">{{ video.name }}</span>
    </mat-card>
  </div>
</div>
<div *ngIf="videoPlaying >= 0" class="overlay"></div>
